import * as React from 'react';

const Columns = (maxMiscellaneousImages: number) => [
  { Header: 'caseId', accessor: 'caseId' },
  { Header: 'agencyCode', accessor: 'agencyCode', width: 125 },
  { Header: 'caseType', accessor: 'caseType' },
  {
    Header: 'public', accessor: 'public',
    Cell: props => props.value.toString()

  },
  { Header: 'status', accessor: 'status' },
  { Header: 'poster', accessor: 'poster' },
  { Header: 'openDate', accessor: 'openDate', width: 125 },
  { Header: 'missingDate', accessor: 'missingDate', width: 125 },
  { Header: 'state', accessor: 'state' },
  { Header: 'city', accessor: 'city' },
  { Header: 'address', accessor: 'address' },
  { Header: 'circumstances', accessor: 'circumstances', width: 145 },
  { Header: 'lastSeen', accessor: 'lastSeen' },
  {
    Header: 'miscellaneous', accessor: 'miscellaneous',
    Cell: props => {
      if (props && props.value) {
        const miscellaneousImages = props.value.split(',');
        return miscellaneousImages.map((image, index) => (<img key={index} src={image} alt={`miscellaneous${index}`} className="miscellaneous-image" />))
      } else {
        return <></>
      }
    },
    width: maxMiscellaneousImages > 0 ? ((maxMiscellaneousImages * 70) + 40) : 100
  },
  { Header: 'personId', accessor: 'personId' },
  { Header: 'personType', accessor: 'personType', width: 120 },
  {
    Header: 'portraitURL', accessor: 'portraitURL',
    Cell: props =>
      props && props.value ? <img src={props.value} alt={'portrait'} /> : <></>,
    width: 120
  },
  {
    Header: 'alternateURL', accessor: 'alternateURL',
    Cell: props =>
      props && props.value ? <img src={props.value} alt={'alternate'} /> : <></>,
    width: 125
  },
  {
    Header: 'progressedURL', accessor: 'progressedURL',
    Cell: props =>
      props && props.value ? <img src={props.value} alt={'progressed'} /> : <></>,
    width: 150
  },
  { Header: 'fullName', accessor: 'fullName', width: 250 },
  { Header: 'age', accessor: 'age' },
  { Header: 'birthDate', accessor: 'birthDate' },
  { Header: 'sex', accessor: 'sex' },
  { Header: 'weight', accessor: 'weight' },
  { Header: 'weightUnit', accessor: 'weightUnit' },
  { Header: 'height', accessor: 'height' },
  { Header: 'heightUnit', accessor: 'heightUnit' },
  { Header: 'eyeColor', accessor: 'eyeColor' },
  { Header: 'hairColor', accessor: 'hairColor' },
  { Header: 'companionType', accessor: 'companionType', width: 150 }
];

export default Columns;



// WEBPACK FOOTER //
// ./src/modules/UserSettings/UploadCases/components/Columns.tsx